exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notEnought {\n  color: #F52F22; }\n\n.toggle {\n  margin-bottom: 10px; }\n\n.numIn {\n  width: 30px; }\n\n.card-title {\n  display: inline; }\n\n.toggle-switch {\n  display: inline;\n  float: right; }\n\n.no-margin {\n  margin-top: 0px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/src/app/action/action.component.scss
// module id = ../../../../../src/app/action/action.component.scss
// module chunks = 1